(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gutter-reviews"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.custom-reviews__tab');

    // Initialize Swiper for all tabs
    function initializeSliders() {
        const tabTypes = ['amazon', 'shopify', 'google'];
        
        tabTypes.forEach(tabType => {
            const sliderContainer = document.getElementById(`slider-${tabType}`);
            console.log(sliderContainer.querySelectorAll('.swiper-slide').length);
          
            // Destroy existing Swiper if initialized
            if (sliderContainer.swiper) {
                sliderContainer.swiper.destroy(true, true);
            }
            
            // Initialize Swiper
            const swiper = new Swiper(sliderContainer, {
                loop: true,
                spaceBetween: 20,
                // slidesPerGroup: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                  500: {
                        centeredSlides: true,
                        roundLengths: true,
                        centeredSlidesBounds: true,
                        initialSlide: 3,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    }
                    
                },
            });

          console.log(swiper);
        });

        // Hide all sliders except the active tab
        hideInactiveSliders();
    }

    // Hide sliders for inactive tabs
    function hideInactiveSliders() {
        const tabTypes = ['amazon', 'shopify', 'google'];
        
        tabTypes.forEach(tabType => {
            const sliderContainer = document.getElementById(`slider-${tabType}`);
            const tab = document.querySelector(`.custom-reviews__tab[data-tab="${tabType}"]`);
            
            if (!tab.classList.contains('active')) {
                sliderContainer.style.display = 'none';
            } else {
                sliderContainer.style.display = 'block';
            }
        });
    }

    // Tab click event
    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            // Remove active class from all tabs
            tabs.forEach(t => t.classList.remove('active'));
            
            // Add active class to clicked tab
            this.classList.add('active');
            
            // Show/hide sliders based on active tab
            // hideInactiveSliders();
            
            // Reinitialize sliders to ensure proper display
            initializeSliders();
        });
    });

    // Initial setup
    initializeSliders();
});

  } catch(e) { console.error(e); }
})();
})();
